import React from 'react';
import PropTypes from 'prop-types';
import { some } from 'lodash';
import FeaturesCompareHeaderCell from './FeaturesCompareHeaderCell';
import BreakpointMatch from '../../common/mediaQuery/BreakpointMatch';
import { combineClassNames } from 'core/css';

const getAltText = header => {
  if (!header) {
    return '';
  }
  return [header.primaryText, header.secondaryText, header.tertiaryText]
    .filter(x => !!x)
    .join(' ');
};

const getScrollbarWidth = () => {
  let scrollDiv = document.createElement('div');
  scrollDiv.style.width = '100px';
  scrollDiv.style.height = '100px';
  scrollDiv.style.overflow = 'scroll';
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  document.body.appendChild(scrollDiv);
  const scrollWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollWidth;
};

const Spacer = ({ width, className }) => {
  if (width === 0) {
    return null;
  }
  return (
    <div
      className={combineClassNames([
        'features-compare-header__scroll-spacer',
        className
      ])}
      style={{ width }}
    />
  );
};

const ImageRow = ({ headers, scrollWidth }) => {
  if (!some(headers, 'imageUrl')) {
    return null;
  }
  return (
    <div>
      <div className="features-compare-header__row show-for-large">
        <div className="show-for-large" style={{ flex: 1 }} />
        {headers.map((header, index, arr) => (
          <div
            key={index}
            className="features-compare-header__image-cell"
            style={{
              marginLeft: index === 0 ? 0 : 1,
              marginRight: index === arr.length - 1 ? 0 : 1
            }}>
            {header && <img alt={getAltText(header)} src={header.imageUrl} />}
          </div>
        ))}
        <Spacer width={scrollWidth} className="invisible" />
      </div>
    </div>
  );
};

class CellsRow extends React.Component {
  render() {
    const {
      headers,
      lockDefaultColumn,
      placeholderText,
      disclaimer,
      scrollWidth,
      onSelect
    } = this.props;
    return (
      <BreakpointMatch
        breakpoint="large"
        render={isMatch => {
          const headersToRender = isMatch ? headers : headers.slice(0, 2);
          return (
            <div className="features-compare-header__row">
              <div className="show-for-large" style={{ flex: 1 }} />
              {headersToRender.map((header, index, arr) => (
                <div
                  key={index}
                  className="features-compare-header__column stat-dropdown"
                  style={{
                    marginLeft: index === 0 ? 0 : 1,
                    marginRight: index === arr.length - 1 ? 0 : 1
                  }}>
                  <FeaturesCompareHeaderCell
                    header={header}
                    disableEdit={index === 0 && lockDefaultColumn}
                    placeholderText={placeholderText}
                    disclaimer={disclaimer}
                    onSelect={() => onSelect(index)}
                  />
                </div>
              ))}
              <Spacer width={scrollWidth} />
            </div>
          );
        }}
      />
    );
  }
}

class FeaturesCompareHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scrollWidth: getScrollbarWidth()
    };
  }

  render() {
    const {
      headers,
      lockDefaultColumn,
      placeholderText,
      disclaimer,
      analyticsKey,
      onSelect
    } = this.props;
    const { scrollWidth } = this.state;

    return (
      <div className="features-compare-header">
        <ImageRow headers={headers} scrollWidth={scrollWidth} />
        <CellsRow
          headers={headers}
          lockDefaultColumn={lockDefaultColumn}
          placeholderText={placeholderText}
          disclaimer={disclaimer}
          analyticsKey={analyticsKey}
          scrollWidth={scrollWidth}
          onSelect={onSelect}
        />
      </div>
    );
  }
}

FeaturesCompareHeader.propTypes = {
  headers: PropTypes.array.isRequired,
  lockDefaultColumn: PropTypes.bool,
  placeholderText: PropTypes.string,
  disclaimer: PropTypes.string,
  analyticsKey: PropTypes.string,
  onSelect: PropTypes.func.isRequired
};

export default FeaturesCompareHeader;
